import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;

export const getSystemNow = async () => {
  console.log('🌐 timeAPI: Calling GET', `${API_BASE_URL}/system/now`);
  const { data } = await axios.get(`${API_BASE_URL}/system/now`);
  console.log('📦 timeAPI: Response received:', data);
  return data; // { iso, unix }
};

export default {
  getSystemNow,
};


